import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-12 px-4 bg-brand-dark relative z-10" data-id="element-170">
      <div className="max-w-3xl mx-auto text-center" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-danger/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_30px_rgba(239,68,68,0.1)]" data-id="element-172">
          <p className="text-lg sm:text-xl md:text-2xl font-medium text-gray-200 leading-relaxed mb-4" data-id="element-173">
            Pianificare le lezioni manualmente ti toglie{' '}
            <span className="text-brand-danger font-bold" data-id="element-174">
              3-5 ore ogni settimana
            </span>
            . Sono{' '}
            <span className="text-brand-danger font-bold" data-id="element-175">
              più di 150 ore all'anno perse
            </span>
            .
          </p>
          <p className="text-base sm:text-lg text-gray-400 leading-relaxed" data-id="element-176">
            Mentre costruisci l'ennesima UDA su Leopardi da zero, cerchi
            materiali su Google che non trovi mai o scrivi griglie di
            valutazione la domenica sera — la tua passione per la letteratura si
            spegne lentamente sotto il peso della burocrazia del MIM.
            <br data-id="element-177" />
            <br data-id="element-178" />
            <span className="text-brand-cream font-bold" data-id="element-179">
              Non è un problema di impegno. È un problema di sistema.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}